if (!customElements.get('subscribe-form')) {
  customElements.define(
    'subscribe-form',
    class SubscribeForm extends HTMLElement {
      constructor() {
        super();

        console.log('Subscribe Form Update!!!');
        this.form = this.querySelector('form');
        console.log('form =', this.form);

        this.form.addEventListener('submit', this.onSubmitPrompt.bind(this));
      }

      onSubmitPrompt(event) {
        // event.prevetDefault();

        console.log('提交处理！！！');
      }
    }
  );
}
